// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { FacilityCountingMode } from "./FacilityCountingMode.gen";
import { FacilityCountBaselineSource } from "./FacilityCountBaselineSource.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";

export interface IFacilityCurrentOccupancy {
	facilityId: string | undefined;

	countingMode: FacilityCountingMode;

	count: number | undefined;

	needsBaseline: boolean;

	baselineCount: number | undefined;

	baselineAsOfDate: string | undefined;

	baselineSource: FacilityCountBaselineSource | undefined;

	changeSinceBaseline: number | undefined;

	countUncertainty: number;

	targetFilter: TargetTypes | number ;

	$type?: string | undefined;
}
export class FacilityCurrentOccupancy {
	constructor(data?: IFacilityCurrentOccupancy) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.baselineAsOfDate) { this.baselineAsOfDate = new Date(data.baselineAsOfDate); }
	}

	facilityId: string | undefined;

	countingMode: FacilityCountingMode = 0;

	count: number | undefined;

	needsBaseline: boolean = false;

	baselineCount: number | undefined;

	baselineAsOfDate: Date | undefined;

	baselineSource: FacilityCountBaselineSource | undefined;

	changeSinceBaseline: number | undefined;

	countUncertainty: number = 0;

	targetFilter: TargetTypes | number  = 0;

	static $type: string = "CoreApi.Models.FacilityCurrentOccupancy, ";
	$type?: string | undefined = FacilityCurrentOccupancy.$type;
}

